import React, { useEffect, useState } from 'react'
import { Typography, Alert, CircularProgress, Box, TextField, Button, TableContainer, Table, TableHead, TableCell, TableRow, Paper, TableBody, Select, MenuItem, FormControl } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { useDispatch, useSelector } from 'react-redux';
import { downloadDocument, getBiocharProductionFuelUse, postBiocharProductionFuelUse } from '../../../../../actions/tigercat-burns/tigercat-actions';
import { getAllProjectsWithAssignedAssets } from '../../../../../actions/tigercat-burns/tigercat-base-actions';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';

const BiocharProductionFuel = ({ projectId, project }) => {

    const [biocharProductionFuelState, setBiocharProductionFuelState] = useState([])
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const projectsWithAssignedEquipment = useSelector(state => state.tigercatBurnsBaseReducer.projectsWithAssignedAssets.data);
    const biocharProductionFuelUses = useSelector(state => state.tigercatBurnsReducer.biocharProductionFuelUses.data);
    const { userData } = useSelector(state => state.auth);
    const userCompanyId = userData?.tigercatBurnsUser?.companyId;
    const [error, setError] = useState(false)
    const handleAddItem = () => {
        setBiocharProductionFuelState((prevState) => {
            const state = [...prevState]
            const formData = {
                id: null,
                date: null,
                equipment: null,
                fuelUsage: null,
                hoursOperated: null,
                fuelConsumed: null,
                runningTotal: null,
                rowId: uuidv4(),
            };
            state.push(formData)
            return state
        })
    }

    useEffect(() => {
        const fuelUses = biocharProductionFuelUses?.map((item) => ({
            ...item,
            disabled: true
        }));
        setBiocharProductionFuelState(fuelUses);
    }, [biocharProductionFuelUses])

    useEffect(() => {
        dispatch(getBiocharProductionFuelUse(projectId));
        dispatch(getAllProjectsWithAssignedAssets(userCompanyId, 'equipment'))
    }, [dispatch, userCompanyId, projectId])

    const handleDateSelection = (date, dataId) => {
        setBiocharProductionFuelState((prevState) => {
            return prevState.map((item) => {
                if (item.rowId === dataId) {
                    const formattedDate = moment(date).format('YYYY-MM-DD');
                    item.date = formattedDate;
                }
                return item;
            });
        });
    }

    const handleEquipmentChange = (e, dataId) => {
        setBiocharProductionFuelState((prevState) => {
            return prevState.map((item) => {
                if (item.rowId === dataId) {
                    item.equipment = e.target.value;
                }
                return item;
            });
        });
    }

    const handleFuelUsageChange = (e, dataId) => {
        setBiocharProductionFuelState((prevState) => {
            return prevState.map((item) => {
                if (item.rowId === dataId) {
                    item.fuelUsage = e.target.value;
                }
                return item;
            });
        });
    }

    const handleHoursOperatedPerDayChange = (e, dataId) => {
        setBiocharProductionFuelState((prevState) => {
            return prevState.map((item) => {
                if (item.rowId === dataId) {
                    item.hoursOperated = e.target.value;
                }
                return item;
            });
        });
    }

    const handleSubmitData = () => {
        let hasError = false
        biocharProductionFuelState.forEach((i) => {
            if (i.date === null || i.equipment === null || i.fuelUsage === null || i.hoursOperated === null) {
                setError(true)
                hasError = true
                return
            }
        })
        console.log(hasError)
        if (!hasError) {
            setError(false)
            dispatch(postBiocharProductionFuelUse(projectId, biocharProductionFuelState)).then(() => {
                dispatch(getBiocharProductionFuelUse(projectId))
                setLoading(false)
            })
        } else {
            setLoading(false)
        }
    }

    const handleDownload = async () => {
        try {
            dispatch(downloadDocument(projectId, 'biochar_production_fuel')).then((response) => {

                // Create a downloadable link for the Excel file
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${project}_biochar_production_fuel.xlsx`); // Set the file name
                document.body.appendChild(link);
                link.click();
                link.remove();
            })

        } catch (err) {
            console.error('Error downloading Equipment Transport:', err);
        }
    };

    return (
        <>
            <h2>Biochar Production Fuel</h2>
            <TableContainer key={0} component={Paper} >
                <Button variant='contained' sx={{ height: 'auto', float: 'right', mt: 2, mb: 2 }} onClick={handleDownload}>Download Excel</Button>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell size="small" align="left">
                                Date
                            </TableCell>
                            <TableCell size="small" align="left">
                                Equipment
                            </TableCell>
                            <TableCell size="small" align="left">
                                Fuel Usage (gal/hr)
                            </TableCell>
                            <TableCell size="small" align="left">
                                Hours operated per day
                            </TableCell>
                            <TableCell size="small" align="left">
                                Fuel consumed per day (gal/day)
                            </TableCell>
                            <TableCell size="small" align="left">
                                Running Total (gal)
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {/* {console.log(biocharProductionFuelState)} */}
                        {biocharProductionFuelState?.map((data, index) => {
                            return (
                                <TableRow key={index}>
                                    <TableCell size="small" align="left">
                                        <FormControl>
                                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                                <DatePicker name={'date'}
                                                    slotProps={{
                                                        textField: {
                                                            error: false,
                                                        }
                                                    }}
                                                    value={data.date ? moment(data.date, 'YYYYMMDD') : null}
                                                    onChange={(e) => handleDateSelection(e, data.rowId)}
                                                    disabled={data.disabled}
                                                    format="MM/DD/YYYY"
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </TableCell>
                                    <TableCell size="small" align="left">
                                        <FormControl sx={{ width: '200px' }}>
                                            {/* <InputLabel id="demo-simple-select-label">{data.equipment}</InputLabel> */}
                                            <Select name='equipment' value={data.equipment === null ? '' : data.equipment} fullWidth onChange={(e) => handleEquipmentChange(e, data.rowId)}
                                                disabled={data.disabled}>
                                                {projectsWithAssignedEquipment?.filter((project) => project.id === projectId)[0]?.equipment?.map(equip => {
                                                    return (
                                                        <MenuItem key={equip._id} value={equip._id}>
                                                            {equip.name}
                                                        </MenuItem>
                                                    );
                                                })}
                                            </Select>
                                        </FormControl>
                                    </TableCell>
                                    <TableCell size="small" align="left">
                                        <TextField
                                            name='fuel usage'
                                            value={data.fuelUsage === null ? '' : data.fuelUsage}
                                            onChange={(e) => handleFuelUsageChange(e, data.rowId)}
                                            type="text"
                                            disabled={data.disabled}
                                        />
                                    </TableCell>
                                    <TableCell size="small" align="left">
                                        <TextField
                                            name='hours operated'
                                            value={data.hoursOperated === null ? '' : data.hoursOperated}
                                            onChange={(e) => handleHoursOperatedPerDayChange(e, data.rowId)}
                                            type="text"
                                            disabled={data.disabled}
                                        />
                                    </TableCell>
                                    <TableCell size="small" align="left">
                                        {data.fuelConsumed === null ? <Typography sx={{ color: 'darkorange' }}>Undetermined</Typography> : data.fuelConsumed}
                                    </TableCell>
                                    <TableCell size="small" align="left">
                                        {data.runningTotal === null ? <Typography sx={{ color: 'darkorange' }}>Undetermined</Typography> : data.runningTotal}
                                    </TableCell>
                                </TableRow>
                            )
                        })}

                    </TableBody>
                </Table>
            </TableContainer>
            {error ? <Alert severity='error' sx={{ my: 2 }}>Please fill out all fields before submitting</Alert> : null}
            <Box sx={{ position: 'relative', mb: 10 }}>
                {loading ? <CircularProgress sx={{ position: 'absolute', left: '125px', top: '12px' }}></CircularProgress> :
                    <Button variant='contained' sx={{ height: 'auto', mt: 2 }} onClick={handleAddItem}>Add Entry</Button>}
                <Button variant='contained' sx={{ height: 'auto', mt: 2, ml: 3 }} onClick={handleSubmitData}>Submit Data</Button>
            </Box>
        </>
    )
}

export default BiocharProductionFuel